export const points = [
    {
        name: 'friends',
        userImage: require('./images/users/friends.png'),
    },
    {
        name: 'discover',
        userImage: require('./images/users/discover.png'),
    },
    {
        name: 'buddy_read',
        userImage: require('./images/users/buddy-read.png'),           
    },
    {
        name: 'library',
        userImage: require('./images/users/library.png'),
    },
]
